import styled from 'styled-components';

export const PageContainer = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  font-family: "AvenirNextLTW01-Regular";
  // padding-bottom: 30px;
  width: 100%;
  background-image: ${(props) => `url(${props.backgroundImage})`};
  // padding-left: 15px;
  // padding-right: 15px;
`;

export const SuccessContainer = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  max-width: 996px;
  justify-content: center;
  margin-top: 80px;
  margin-bottom: 40px;
  margin-left: 15px;
  margin-right: 15px;
  align-items: end;
`;

export const GoalcardContainer = styled.div`
  width: 50%;
  min-width: 280px;
  max-width: 310px;
  // max-height: 230px;
  border-radius: 6px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
  background-color: #fff;
  padding: 10px;
  margin-right:65px;
`;

export const GoalcardImage = styled.img`
  min-height: 200px;
  max-width: 100%;
  text-align: center;
`;

export const TitleContainer = styled.div`
  display:flex;
  flex-direction: column;
  width: 90%;
  // align-items: center;
  // margin: 30px 0px 10px 0;
  // text-align: center;
`;

export const Title = styled.label`
  font-size: 26px;
  font-weight: 300;
  line-height: 1.3;
  font-family: "AvenirNextLTW01-Regular";
  color: #fff;
  // margin-bottom: 20px;
`;

export const TitleBold = styled.label`
  font-size: 26px;
  font-weight: 900;
  line-height: 1.3;
  font-family: "AvenirNextLTW01-Regular";
  color: #fff;
  // margin-bottom: 20px;
`;

export const InfoContainer = styled.div`
  display:flex;
  flex-direction: column;
  width: 80%;
  align-items: flex-start;
  height: 100%;
  // margin-bottom: 30px;
  // margin-top: ${(props) => (props.isMobile ? '30px;' : '0px;')}
`;

export const Description = styled.label`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  font-family: "AvenirNextLTW01-Regular";
  color: #fff;
`;

export const ButtonContainer = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  display: inline-block;
  min-width: 140px;
  height: 45px;
  // margin: 0 10px 45px;
  line-height: 45px;
  background-color: #F3A802;
  outline: none;
  border: 0;
  border-radius: 5px;
  color: #fff;
  text-transform: uppercase;
  font-size: .9em;
  text-align: center;
  opacity: 1;
  padding: 0 18px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'Avenir Next LT W01 Demi';
  transition: all .35s;
  &:hover {
    background-color: #f39502;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 15px;
  }
`;

export const SupportLabelContainer = styled.div`
  display:flex;
  flex-direction: row;
  background-color: #3b2f71;
  margin-bottom: 15px;
  width: 100%;
  justify-content: center;
  margin-top: 40px;
`;

export const SupportLabel = styled.label`
  font-size: 13px;
  margin: 7px 0;
  line-height: 1.75;
  font-weight: 400;
  color: #fff;
  text-align: center;
`;

export const SupportEmail = styled.a`
  color: #F3A802;
  border-bottom: 1px solid;
  text-decoration: none;
`;
